import React, { useState } from 'react';
import PuzzleGrid from './PuzzleGrid';
import { getDifficulty } from '../utils/puzzleUtils';

const NewVersionPreview = ({ puzzles, onRemovePuzzle, onReorderPuzzles }) => {
  const [filters, setFilters] = useState({ difficulty: '', gridSize: '' });

  const filteredPuzzles = puzzles.filter(puzzle => 
    (filters.difficulty ? getDifficulty(puzzle.fice_score) === filters.difficulty : true) &&
    (filters.gridSize ? puzzle.pattern.length === parseInt(filters.gridSize) : true)
  );

  const handleReorder = (dragIndex, hoverIndex) => {
    const reorderedPuzzles = [...puzzles];
    const [removed] = reorderedPuzzles.splice(dragIndex, 1);
    reorderedPuzzles.splice(hoverIndex, 0, removed);
    onReorderPuzzles(reorderedPuzzles);
  };

  return (
    <div className="new-version-preview">
      <h2>New Version Preview</h2>
      <p>Puzzle count: {puzzles.length}</p>
      <div className="filters">
        <select 
          value={filters.difficulty} 
          onChange={(e) => setFilters({...filters, difficulty: e.target.value})}
        >
          <option value="">All Difficulties</option>
          <option value="Easy">Easy</option>
          <option value="Medium">Medium</option>
          <option value="Hard">Hard</option>
          <option value="Expert">Expert</option>
        </select>
        <select 
          value={filters.gridSize} 
          onChange={(e) => setFilters({...filters, gridSize: e.target.value})}
        >
          <option value="">All Sizes</option>
          <option value="4">4x4</option>
          <option value="8">8x8</option>
        </select>
      </div>
      <PuzzleGrid 
        puzzles={filteredPuzzles} 
        onPuzzleClick={onRemovePuzzle} 
        onReorder={handleReorder}
        actionIcon="remove"
      />
    </div>
  );
};

export default NewVersionPreview;